import React from 'react';
import { Link } from 'react-router-dom';

interface BrandMarkProps {
  compact?: boolean;
  className?: string;
}

const BrandMark: React.FC<BrandMarkProps> = ({ compact = false, className = '' }) => (
  <Link
    to="/"
    className={`inline-flex items-center gap-2.5 rounded-md focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-500 focus-visible:ring-offset-2 ${className}`}
    aria-label="1MED home"
  >
    <img
      src="/assets/cropped-1med_logo_1.png"
      alt=""
      className="h-8 w-8 flex-none rounded-lg object-cover shadow-sm"
      aria-hidden="true"
    />
    {!compact && (
      <span className="leading-none">
        <span className="block text-[15px] font-semibold tracking-[-0.025em] text-slate-950">1MED</span>
        <span className="mt-1 block text-[9px] font-medium tracking-wide text-slate-500">Medical workspace</span>
      </span>
    )}
  </Link>
);

export default BrandMark;
